// extracted by mini-css-extract-plugin
module.exports = {"bottles":"_2fwu5j","bottle":"_2Kcqg5","title":"_3MW6kA","shine-lines":"_1CJyDQ"};